import { PosVendaProtocoloTipo, PosVendaProtocolosFiltros } from '../../types/posVenda';
import { tipoProtocoloParaApi } from './posVendaTipoCatalog';

/** `PosVendaProtocoloTipo.EnvioViaCorreio` na GettelApi. */
export const POS_VENDA_TIPO_ID_ENVIO_VIA_CORREIO = 19;

/** SilentAtivacaoChip — fluxo linha nova etapa 01 (GettelApi #538). */
export const POS_VENDA_TIPO_ID_SILENT_ATIVACAO_CHIP = 28;

/** Tipos do fluxo linha nova (tickets por etapa). */
export const TIPOS_FLUXO_LINHA_NOVA: PosVendaProtocoloTipo[] = [
  'SilentAtivacaoChip',
  'ConfirmacaoEndereco',
  'ConfirmacaoEntrega',
];

/** Kanban aba Logística: fluxo linha nova + envio via correio (tipo 19). */
export const TIPOS_ESCOPO_LOGISTICA_KANBAN: PosVendaProtocoloTipo[] = [
  ...TIPOS_FLUXO_LINHA_NOVA,
  'EnvioViaCorreio',
];

/**
 * Valor default de `excluirTipos` na fila de atendimento (#538).
 * A API pode ampliar; o mock também filtra por `TIPOS_ESCOPO_LOGISTICA_KANBAN`.
 */
export const EXCLUIR_TIPOS_FILA_ATENDIMENTO = `${POS_VENDA_TIPO_ID_ENVIO_VIA_CORREIO},${POS_VENDA_TIPO_ID_SILENT_ATIVACAO_CHIP}`;

export type EscopoListagemProtocolos = 'atendimento' | 'logistica';

export function isTipoEscopoLogisticaKanban(tipo: PosVendaProtocoloTipo | string): boolean {
  const canon = tipoProtocoloParaApi(String(tipo));
  return TIPOS_ESCOPO_LOGISTICA_KANBAN.includes(canon);
}

function parseExcluirTiposIds(raw: string | number | undefined): number[] {
  if (raw === undefined || raw === null || raw === '') return [];
  return String(raw)
    .split(',')
    .map((s) => Number(s.trim()))
    .filter((n) => !Number.isNaN(n));
}

const TIPO_PARA_ID_API: Partial<Record<PosVendaProtocoloTipo, number>> = {
  EnvioViaCorreio: POS_VENDA_TIPO_ID_ENVIO_VIA_CORREIO,
  SilentAtivacaoChip: POS_VENDA_TIPO_ID_SILENT_ATIVACAO_CHIP,
};

export function tipoEstaEmExcluirTipos(
  tipo: PosVendaProtocoloTipo | string,
  excluirTipos: string | number | undefined
): boolean {
  const ids = parseExcluirTiposIds(excluirTipos);
  const canon = tipoProtocoloParaApi(String(tipo));
  const id = TIPO_PARA_ID_API[canon];
  if (id != null && ids.includes(id)) return true;
  if (isTipoEscopoLogisticaKanban(canon)) return true;
  return false;
}

/** Aplica escopo UI → parâmetros de listagem (API + mock). */
export function mergeEscopoListagemProtocolos(
  filtros: PosVendaProtocolosFiltros,
  escopo: EscopoListagemProtocolos = 'atendimento'
): PosVendaProtocolosFiltros {
  if (escopo === 'logistica') {
    return {
      ...filtros,
      escopoListagem: 'logistica',
      excluirTipos: undefined,
      apenasEnvioCorreio: undefined,
      apenasLogistica: true,
      incluirLogisticaNoKanban: true,
    };
  }
  return {
    ...filtros,
    escopoListagem: 'atendimento',
    apenasLogistica: undefined,
    apenasEnvioCorreio: undefined,
    incluirLogisticaNoKanban: false,
    excluirTipos: filtros.excluirTipos ?? EXCLUIR_TIPOS_FILA_ATENDIMENTO,
  };
}

/** Filtros para POST /pegar-proximo (mesmo escopo da listagem, sem paginação/status). */
export function filtrosParaPegarProximoApi(
  filtros: PosVendaProtocolosFiltros
): PosVendaProtocolosFiltros {
  const { status: _s, page: _p, pageSize: _ps, ...rest } = filtros;
  return rest;
}
